//node_modules
import React, { FunctionComponent } from "react";
import { NextSeo, ArticleJsonLd } from "next-seo";

//helpers
import getImageLoaderAbsoluteSrc from "@adjust/website/libs/helper/getImageLoaderAbsoluteSrc";

//hooks
import useCanonical from "@adjust/src/hooks/useCanonical";

//types
import type { BlogDocument } from "@adjust/libs/database/blogs";

type BlogMetaProps = {
  blog: BlogDocument;
};

const MetaComponent: FunctionComponent<BlogMetaProps> = ({ blog }) => {
  const canonical = useCanonical();
  const src = getImageLoaderAbsoluteSrc(blog.ogImage, 1200);

  const published = new Date(blog.publishedTime).toISOString();
  const modified = new Date(blog.modifiedTime).toISOString();

  return (
    <>
      <NextSeo
        title={blog.title}
        description={blog.description}
        canonical={canonical}
        noindex={false}
        nofollow={false}
        openGraph={{
          type: "article",
          siteName: "Adjust to the Good Life Travel",
          url: canonical,
          title: blog.title,
          description: blog.description,
          article: {
            section: "Travel",
            publishedTime: published,
            modifiedTime: modified,
          },
          images: [
            {
              url: src,
            },
          ],
        }}
        twitter={{
          cardType: "summary_large_image",
        }}
      />
      <ArticleJsonLd
        type="BlogPosting"
        url={canonical}
        title={blog.title}
        description={blog.description}
        images={[src]}
        datePublished={published}
        dateModified={modified}
        isAccessibleForFree={true}
        authorName={blog.authors}
      />
    </>
  );
};

export default React.memo(MetaComponent);
